module.exports = __webpack_public_path__ + "img/service-consulting-3.c56e0183.jpg";